"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastFourDigitFilter = void 0;
class LastFourDigitFilter {
    constructor() {
        this.lastFourDigit = '';
    }
    transform(value) {
        if (value) {
            this.inputStr = value.toString();
            if (this.inputStr.length >= 4) {
                this.lastFourDigit = this.inputStr.substr(this.inputStr.length - 4);
            }
        }
        return this.lastFourDigit;
    }
}
exports.LastFourDigitFilter = LastFourDigitFilter;
//# sourceMappingURL=fourDigitNumber.pipe.js.map